import {
  Box,
  LinearProgress,
  LinearProgressProps,
  styled,
  Typography,
} from "@mui/material";

interface Props extends LinearProgressProps {
  value: number;
  error?: boolean;
}
export function LinearProgressWithLabel(props: Props) {
  const { value, className, error, ...linearProgressProps } = props;
  return (
    <StyledBox className={className}>
      <Box className="progress-wrapper">
        <LinearProgress
          value={value}
          variant="determinate"
          {...linearProgressProps}
        />
      </Box>
      <Box className="label-wrapper">
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          value
        )}%`}</Typography>
      </Box>
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  .progress-wrapper {
    width: 100%;
    margin-right: ${({ theme }) => theme.spacing(1)};
    .MuiLinearProgress-root {
      height: 10px;
      border-radius: 5px;
    }
  }
  .label-wrapper {
    min-width: 35px;
  }
`;
